<template>

  <div class="col-lg-12  mb-4">
      <v-card flat>
        <apexchart type="line" height="350" :options="chartOptions" :series="series"></apexchart>
      </v-card>
    </div>
  </template>
  
  <script>
  import apexchart from 'vue-apexcharts'
  
  export default {
    name: 'LineChart',
    components: {
      apexchart
    },
    mounted(){
      this.getSeriesFromData();
    },
    data() {
      return {
            series: [],
            chartOptions: {
              chart: {
                height: 350,
                type: 'line',
                dropShadow: {
                  enabled: true,
                  color: '#000',
                  top: 6,
                  left: 2,
                  blur: 6,
                  opacity: 0.05
                },
                toolbar: {
                  show: false
                }
              },
              colors: ['#8B5AF4', '#43D9AF', '#FF7299', '#848484'],
              dataLabels: {
                enabled: true,
              },
              stroke: {
                curve: 'smooth'
              },
              title: {
                text: '',
                align: 'left'
              },
              grid: {
                borderColor: '#e7e7e7',
                row: {
                  colors: ['transparent'], // takes an array which will be repeated on columns
                  opacity: 0.5
                },
              },
              markers: {
                size: 1
              },
              xaxis: {
                categories: this.getCategories(),
                title: {
                  text: ''
                }
              },
              yaxis: {
                min: this.getMinMaxFromdata("min"),
                max: this.getMinMaxFromdata("max"),
                reversed:true
              },
              legend: {
                position: 'top',
                horizontalAlign: 'right',
                floating: true,
                offsetY: -25,
                offsetX: -5
              }
            }
          }
        },
    /* computed:{
      chart() {
        return this.$refs.chart.getCurrentChart;
      }
    },   */
    props: {
      data:{
          type: Array
      },
    },
    methods:{
      getMinMaxFromdata(type){
        let values = [];
        values.push(this.data.map(e => e.completed))
        values.push(this.data.map(e => e.empty))
        values.push(this.data.map(e => e.partial))
        if(type == "min"){
          return Math.min(values);
        }
        if(type == "max"){
          return Math.max(values);
        }
      },
      getCategories(){
        //return this.data.map(e => new Date(e.timestamp).toLocaleDateString('de-DE'));
      },
      getSeriesFromData(){
        this.series.push({
          name: "Trend",
          data: this.data
        })
        /* this.series.push({
          name: "Beantwortet",
          data: this.data.map(e => e.completed)
        });
        this.series.push({
          name: "Nicht beantwortet",
          data: this.data.map(e => e.empty)
        })
  
        this.series.push({
          name: "Teilweise beantwortet",
          data: this.data.map(e => e.partial)
        }) */
      }
    } 
  }
  </script>
  
  

<!-- <template>
  <LineChartGenerator
    ref="chart"
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Line as LineChartGenerator } from 'vue-chartjs/legacy'
import Vue from 'vue';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
)

export default {
  name: 'LineChart',
  components: {
    LineChartGenerator
  },
  computed:{
    chart() {
      return this.$refs.chart.getCurrentChart;
    }
  },  
  props: {
    data:{
        type: Object
    },
    chartId: {
      type: String,
      default: 'line-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dataLoaded: false,
      chartData: {
        labels: [],
        datasets: [
          /* {
            label: 'Data One',
            backgroundColor: '#f87979',
            data: []
          } */
        ],
        
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        onClick: this.handleClick,
        scales: {
          y: {
            ticks: {
              stepSize: 1,
              min: 1,
              max: 6,
              autoSkip:false,
            },
          }
        }
      }
    }
  },
  mounted(){
    let self = this;
    this.data.forEach(elem => {
      //let color = '#'+(Math.random()*0xFFFFFF<<0).toString(16);
      Vue.set(elem, 'overallScore', this.calcOverallScore(elem));
    })
    this.chartData.datasets.push({
        label: 'Antworten',
        backgroundColor: '#f87979',
        data: this.data.map(e => e.overallScore)
    }) 
    this.chartData.labels = this.data.map(e => new Date(e.timestamp).toLocaleDateString('de-DE'))
    this.dataLoaded = true;
  },
  methods:{
    calcOverallScore(timestamp){
      let scoreCount = 0;
      let score = 0;

      timestamp.node.forEach(n => {
        score += n.score;
        ++scoreCount;
      })
      return score/scoreCount;
    },
    handleClick(point, event){
      if(event == null) return;
      let indexClicked = event[0].index;
      this.$emit("pointClicked", indexClicked);
    }
  }
}
</script>

 -->